module.exports = __webpack_public_path__ + "static/media/mermaid-story.44dd18b5.md";